module.exports = "/_next/static/images/directional-drilling-excellence-91142783c32df2c181117b2c7193e6ab.webp";